<template>
  <div class="animation-overlay">
    <lottie-player autoplay loop :src="lottieSrc" style="width: 400px; height: 400px" />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

const lottieSrc = computed(() => {
  const meditateJyranianSrc = "/Lottie/jyranian-meditate-docs.json";
  const shopKeeperJyranianSrc = "/Lottie/shop-owner-loading.json";
  const randomNumber = Math.round(Math.random());
  return randomNumber > 0 ? meditateJyranianSrc : shopKeeperJyranianSrc;
});
</script>
<style scoped lang="less">
@import (reference) "../../styles/bootstrap/variables.less";

.animation-overlay {
  //height: 100%;
  //width: 100%;
  margin-top: -20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
